import { createFeatureSelector, createSelector } from "@ngrx/store";
import { InitialStateUser } from "./user.reducer";

export const selectUserLogged = createSelector(
  createFeatureSelector('userState'),
  (userState: InitialStateUser) => {
      return userState.user;
  }
)
export const selecttokensLogged = createSelector(
  createFeatureSelector('userState'),
  (userState: InitialStateUser) => {
      return userState.token;
  }
)
